import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { X } from "lucide-react";
import type { ChatFeedbacksFilters } from "@/types/chat-feedback";

interface Props {
  filters: ChatFeedbacksFilters;
  onFiltersChange: (next: ChatFeedbacksFilters) => void;
}

export function ChatFeedbackFilters({ filters, onFiltersChange }: Props) {
  const hasActiveFilters = Boolean(filters.rating);

  const clearFilters = () => {
    onFiltersChange({});
  };

  return (
    <div className="space-y-4">
      <div className="flex flex-col gap-4 md:flex-row md:items-center">
        <Select
          value={filters.rating ?? "ALL"}
          onValueChange={(value) =>
            onFiltersChange({
              ...filters,
              rating: value === "ALL" ? undefined : (value as "up" | "down"),
            })
          }
        >
          <SelectTrigger
            className="w-full md:w-[180px]"
            aria-label="Filter by rating"
          >
            <SelectValue placeholder="평가 선택" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="ALL">전체 평가</SelectItem>
            <SelectItem value="up">추천</SelectItem>
            <SelectItem value="down">비추</SelectItem>
          </SelectContent>
        </Select>

        {hasActiveFilters && (
          <Button
            variant="ghost"
            onClick={clearFilters}
            className="w-full md:w-auto min-h-[44px] md:min-h-0"
            aria-label="Clear filters"
          >
            <X className="mr-2 h-4 w-4" />
            초기화
          </Button>
        )}
      </div>

      {hasActiveFilters && (
        <div className="flex flex-wrap items-center gap-2">
          <span className="text-xs text-muted-foreground">필터:</span>
          {filters.rating && (
            <Badge variant="secondary" className="gap-1 pr-1">
              평가: {filters.rating === "up" ? "추천" : "비추"}
              <button
                type="button"
                onClick={() =>
                  onFiltersChange({ ...filters, rating: undefined })
                }
                className="ml-1 rounded-full p-0.5 hover:bg-muted"
                aria-label="평가 필터 제거"
              >
                <X className="h-3 w-3" />
              </button>
            </Badge>
          )}
        </div>
      )}
    </div>
  );
}
